module.exports = __webpack_public_path__ + "static/Q5Answer4_blue_ToaHeftiba-e7c5c885f68a7488d70f7d2b5a591281.jpg";